"client-only";

import type { Clerk } from "@clerk/types";
import axios, { type AxiosRequestConfig } from "axios";

const getClerkClientToken = async (): Promise<string | null> => {
	try {
		const clerk = window?.Clerk;
		if (clerk?.session?.getToken) {
			return await clerk.session.getToken();
		}
	} catch {
		// Swallow any runtime issues quietly.
	}
	return null;
};

export async function fetcher<T = any>(
	url: string,
	config: AxiosRequestConfig & {
		token?: string;
		api?: "ai" | "chat" | "main";
	} = {},
): Promise<T> {
	const { api = "main", headers, baseURL: customBaseURL, ...rest } = config;

	const baseURL =
		customBaseURL ||
		(api === "ai"
			? process.env.NEXT_PUBLIC_AI_API_URL
			: api === "chat"
				? process.env.NEXT_PUBLIC_CHAT_API_URL
				: process.env.NEXT_PUBLIC_API_URL);

	const finalHeaders: Record<string, any> = { ...(headers || {}) };

	const token = config.token ?? (await getClerkClientToken());

	if (!finalHeaders.Authorization && token) {
		finalHeaders.Authorization = `Bearer ${token}`;
	}

	const response = await axios.request<T>({
		url,
		baseURL,
		headers: finalHeaders,
		...rest,
	});

	return response.data;
}

export default fetcher;

declare global {
	interface Window {
		Clerk: Clerk | undefined;
	}
}
